export const CUSTOM_FIELD_TYPES = {
  SELECT: 'SELECT',
  COLOR: 'COLOR',
};
